import React from "react";
import moment from "moment";
import { FormGroup, InputGroup, Intent, Button } from '@blueprintjs/core';
import Flexbox from 'flexbox-react';

const ProfileElementV2 = ({ element }) => {
  const { name, value, field_type, field_options } = element;

  let displayValue;

  // Handle empty / null
  if (value === null || value === undefined || value === "") {
    displayValue = <em>No Response</em>;
  } else {
    switch (field_type) {
      case "date":
        const date = moment(value).format('MMMM Do YYYY');        
        displayValue =  <Flexbox alignItems='center' >
            <span className="bp3-icon bp3-icon-calendar push-10-r push-5-b  bp3-text-muted" />
            <p className="form-text-display">{date}</p>
          </Flexbox>
      
        break;

      case "datetime":
        displayValue = moment(value).isValid()
          ? moment(value).format("DD MMM YYYY, HH:mm")
          : value;
        break;

      case "time":
        displayValue = moment(value, moment.ISO_8601).isValid()
          ? moment(value).format("HH:mm")
          : value;
        break;

      case "select": {
        const option = field_options?.find((opt) => opt.value === value);
        displayValue = option ? option.label : value;
        break;
      }

      case "multi_select":
        displayValue = Array.isArray(value)
          ? value
              .map((val) => {
                const opt = field_options?.find((o) => o.value === val);
                return opt ? opt.label : val;
              })
              .join(", ")
          : value;
        break;

      case "boolean":
      case "checkbox":
        displayValue = value ? "Yes" : "No";
        break;

    

      case "email":
        displayValue = 
        <Flexbox alignItems='center' >
        <span className="bp3-icon bp3-icon-envelope push-10-r" />
        <a href={`mailto:${value}`}>{value}</a>;
        </Flexbox>
        break;

      case "phone":
      case "number":  
      case "tel":
        displayValue = <p className="form-text-display">{value}</p>;
        break;

      case "url":
      case "hyperlink_input":  
      case "link":
        displayValue = 
        <Flexbox>
        <span className="bp3-icon bp3-icon-globe push-10-r push-5-t bp3-text-muted" />
        <p className="form-text-display">
          <a href={`//${value}`} rel="noreferrer noopener" target="_blank">
            {value}
          </a>
        </p>
      </Flexbox>
        break;

        case "textarea":
          case "long_text":
            displayValue = <div style={{ whiteSpace: "pre-wrap" }}>{value}</div>;
            break;

           
              case "text_input":{
                let parsedValue = value;
              
                if (typeof value === "string") {
                  try {
                    // First parse
                    let tryParse = JSON.parse(value);
              
                    // If still a string after parsing, try again
                    if (typeof tryParse === "string") {
                      tryParse = JSON.parse(tryParse);
                    }
              
                    if (Array.isArray(tryParse)) {
                      parsedValue = tryParse;
                    }
                  } catch (e) {
                    // if looks like array but invalid JSON, try manual cleanup
                    if (value.startsWith("[") && value.endsWith("]")) {
                      parsedValue = value
                        .replace(/^\[|\]$/g, "") // remove [ ]
                        .replace(/['"]+/g, "")   // remove quotes
                        .split(",")              // split by comma
                        .map(v => v.trim());
                    }
                  }
                }
              
                if (Array.isArray(parsedValue)) {
                  displayValue = (
                    <div>
                      {parsedValue.map((item, idx) => (
                        <div key={idx}>{item}</div>
                      ))}
                    </div>
                  );
                } else {
                  displayValue = <div style={{ whiteSpace: "pre-wrap" }}>{parsedValue}</div>;
                }
                break;
              }
          

      case "json":
        displayValue = (
          <pre style={{ whiteSpace: "pre-wrap" }}>
            {JSON.stringify(value, null, 2)}
          </pre>
        );
        break;

      default:
        displayValue = value;
    }
  }

  return (
    <Flexbox flexGrow={1} flexDirection="column" className='pad-30-l pad-30-r pad-10-t pad-10-b'>
      <Flexbox
            flexGrow={1}
            flexDirection="column"
            marginBottom="10px"
            paddingRight="30px"
            minHeight="40px"
           // className={`element_${this.props.element.id}`}
          >
              <label style={{ fontWeight: "bold", display: "block", marginBottom: "9px"}}>
         {name}
      </label>
      <div>{displayValue}</div>
          </Flexbox>
  </Flexbox>
    // <div className="profile-element" style={{ marginBottom: "12px" }}>
    //   <label style={{ fontWeight: "bold", display: "block", marginBottom: "1px",  lineHeight: "1.4" }}>
    //     {name}
    //   </label>
    //   <div>{displayValue}</div>
    // </div>
  );
};

export default ProfileElementV2;
